import { useSizeClass } from '../../contexts/SizeClassContext';

const MAX_PROMPT_SIZE = 360;

export default function usePlayerPromptSize(): {
  contentMargin: number;
  maxWidth: number;
} {
  const { windowWidth, smallestWindowWidth } = useSizeClass();
  const contentMargin = smallestWindowWidth * 0.07;
  const maxWidth = Math.min(MAX_PROMPT_SIZE, windowWidth - contentMargin * 2);

  return {
    contentMargin,
    maxWidth,
  };
}
